﻿import FeatureTemplates from "@arcgis/core/widgets/FeatureTemplates";
import {arcGisObjectRefs} from "./arcGisJsInterop";
import {buildJsFeatureTemplate} from "./jsBuilder";
import TemplateItem from "@arcgis/core/widgets/FeatureTemplates/TemplateItem";

export default class FeatureTemplatesWidgetWrapper {
    private FeatureTemplate: FeatureTemplates;

    constructor(featureTemplates: FeatureTemplates) {
        this.FeatureTemplate = featureTemplates;
    }

    select(item) {
        let templateItem = {
            description: item.description,
            label: item.label,
            layer: arcGisObjectRefs[item.layer.id],
            template: buildJsFeatureTemplate(item.template),
            thumbnail: item.thumbnail
        } as TemplateItem;
        this.FeatureTemplate.select(templateItem);
    }
}